import React from 'react'
import inexogyLogo from 'src/Resources/Images/extensions/inexogy-logo.png'

/**
 * Logo of inexogy - one of e3dc's partners.
 */
const InexogyLogo: React.FC = () => {
  return <img src={inexogyLogo} alt="Inexogy Logo" style={{ width: '100%', height: '100%' }} />
}

export default InexogyLogo
